import styled from 'styled-components';

interface Point {
  x: number;
  y: number;
}

interface Props {
  startPoint: Point;
  endPoints: Point[];
  branchX: number;
  color?: string;
  addedHorizontalMargin?: number;
}

export function BranchingElbowConnector(props: Props) {
  const { startPoint, endPoints, branchX, addedHorizontalMargin = 0 } = props;
  const circleRadius = 4;
  const lines = endPoints.map((endPoint, index) => {
    const circleMargin = 5;

    const sign = Math.sign(endPoint.x - startPoint.x);
    const cx = endPoint.x - (circleMargin + circleRadius + addedHorizontalMargin) * sign;

    const linePoints = [
      {
        x: startPoint.x,
        y: startPoint.y,
      },
      {
        x: branchX - circleRadius * sign,
        y: startPoint.y,
      },
      {
        x: branchX - circleRadius * sign,
        y: endPoint.y,
      },
      {
        x: cx - Math.sign(endPoint.x - startPoint.x) * circleRadius,
        y: endPoint.y,
      },
    ];
    const pointString = linePoints.map(d => `${d.x},${d.y}`).join(' ');

    const color = props.color || '#b3b3b3';
    return (
      <g key={index}>
        <Line points={pointString} stroke={color} />
        <circle cx={cx} cy={endPoint.y} r={circleRadius} stroke={color} fill="transparent" />
      </g>
    );
  });

  return <G>{lines}</G>;
}

const G = styled.g`
  pointer-events: none;
`;

const Line = styled.polyline`
  shape-rendering: crispEdges;
  fill: transparent;
  vector-effect: non-scaling-stroke;
`;
